module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    ref: "modal",
    staticClass: "formens-modal"
  }, [_c('span', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._t("activator")], 2), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Formens Product")]), _vm._v(" "), _c('div', {
    staticClass: "ui left aligned",
    attrs: {
      "slot": "toolbar"
    },
    slot: "toolbar"
  }, [(!_vm.ready) ? _c('div', {
    staticClass: "ui disabled positive button"
  }, [_vm._v("Validate")]) : _vm._e(), _vm._v(" "), (_vm.ready) ? _c('div', {
    staticClass: "ui positive button",
    on: {
      "click": function($event) {
        return _vm.addToCart()
      }
    }
  }, [_vm._v("\n      Validate\n    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "editor"
  }, [_c('div', {
    staticClass: "line"
  }, [_c('label', [_vm._v("Formens Ref")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formensProduct.formens_ref),
      expression: "formensProduct.formens_ref"
    }],
    domProps: {
      "value": (_vm.formensProduct.formens_ref)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formensProduct, "formens_ref", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('label', [_vm._v("Product Type")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formensProduct.product_type),
      expression: "formensProduct.product_type"
    }],
    domProps: {
      "value": (_vm.formensProduct.product_type)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formensProduct, "product_type", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('label', [_vm._v("Fabric Ref")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formensProduct.fabric_ref),
      expression: "formensProduct.fabric_ref"
    }],
    domProps: {
      "value": (_vm.formensProduct.fabric_ref)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formensProduct, "fabric_ref", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('label', [_vm._v("Pattern Base")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formensProduct.pattern_base),
      expression: "formensProduct.pattern_base"
    }],
    domProps: {
      "value": (_vm.formensProduct.pattern_base)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formensProduct, "pattern_base", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('label', [_vm._v("Base Size")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formensProduct.base_size),
      expression: "formensProduct.base_size"
    }],
    domProps: {
      "value": (_vm.formensProduct.base_size)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formensProduct, "base_size", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('label', [_vm._v("Suggested Price")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.formensProduct.price),
      expression: "formensProduct.price",
      modifiers: {
        "number": true
      }
    }],
    domProps: {
      "value": (_vm.formensProduct.price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formensProduct, "price", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('label', [_vm._v("Match Prestashop Product")])]), _vm._v(" "), (_vm.id_product) ? _c('div', {
    staticClass: "line"
  }, [_c('p', [(_vm.id_product) ? _c('span', [_c('span', {
    staticClass: "product-key"
  }, [_vm._v("Product id")]), _vm._v(" :\n            "), _c('span', {
    staticClass: "formens"
  }, [_vm._v(_vm._s(_vm.id_product))])]) : _vm._e(), _vm._v("\n           \n          "), (_vm.id_product_attribute) ? _c('span', [_c('span', {
    staticClass: "product-key"
  }, [_vm._v("Combination id")]), _vm._v(" :\n            "), _c('span', {
    staticClass: "formens"
  }, [_vm._v(_vm._s(_vm.id_product_attribute))])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [(!_vm.products.length) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    staticClass: "search-input",
    attrs: {
      "placeholder": "Search Prestashop products here"
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  }) : _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.id_product),
      expression: "id_product"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.id_product = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.products), function(product) {
    return _c('option', {
      key: product.id_product,
      domProps: {
        "value": product.id_product
      }
    }, [_vm._v("\n            " + _vm._s(product.name + ' - ' + product.formatted_price) + "\n          ")])
  }), 0), _vm._v(" "), _c('span', {
    staticClass: "actions"
  }, [(!_vm.products.length) ? _c('span', [(_vm.disableSearch) ? _c('i', {
    staticClass: "ui disabled blue search icon"
  }) : _c('i', {
    staticClass: "ui blue search icon",
    on: {
      "click": _vm.search
    }
  })]) : _vm._e(), _vm._v(" "), _c('span', [(_vm.disableClearProduct) ? _c('i', {
    staticClass: "ui disabled red eraser icon"
  }) : _c('i', {
    staticClass: "ui red eraser icon",
    on: {
      "click": _vm.clearProduct
    }
  })])])]), _vm._v(" "), (_vm.currentProductCombinations) ? _c('div', [_c('div', {
    staticClass: "line"
  }, [_c('label', [_vm._v("Product combination")])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.id_product_attribute),
      expression: "id_product_attribute"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.id_product_attribute = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.currentProductCombinations), function(combination) {
    return _c('option', {
      key: combination.id_product_attribute,
      domProps: {
        "value": combination.id_product_attribute,
        "selected": combination.default_on == '1' ? 'selected' : ''
      }
    }, [_vm._v("\n              " + _vm._s(combination.attributes) + " - " + _vm._s(combination.formatted_price) + "\n            ")])
  }), 0), _vm._v(" "), _c('span', {
    staticClass: "actions"
  }, [(_vm.disableClearCombination) ? _c('i', {
    staticClass: "ui disabled orange eraser icon"
  }) : _c('i', {
    staticClass: "ui orange eraser icon",
    on: {
      "click": _vm.clearCombination
    }
  })])])]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a0ab7aa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal/FormensModal.vue
// module id = 483
// module chunks = 1